export interface DataTable {
  id: number;
  creationDate?: string;
  updatedDate?: string;
  name: string;
  country: string;
  data: string;
}

export interface DataTableLegend {
  name: string;
  data: {
    [index: string]: unknown;
  };
}

export const nameRules = [
  (value: string) => {
    if (value) return true;

    return 'Name is required.';
  },
  (value: string) => {
    if (value.toLowerCase() === value) return true;

    return 'Name should be all lowercase.';
  },
  (value: string) => {
    if (value.indexOf(' ') === -1) return true;

    return 'Name should not contain spaces.';
  },
];

export const dataRules = [
  (value: string) => {
    if (value) return true;

    return 'Data is required.';
  },
  (value: string) => {
    try {
      JSON.parse(value);
    } catch (e) {
      return 'Data should be valid JSON.';
    }
    return true;
  },
];
